<ng-container *ngIf="(files$ | async) as files">
  <ng-container *ngIf="files && files.length > 0">
    <div class="container-fluid mt-4" style="padding-bottom:50px">
      <div class="it-list-wrapper mb-4">
        <h6 class="link-list-heading d-inline-block">{{props?.label ? props?.label : 'Allegati'}}</h6>
        <div class="row justify-content-end d-inline-block float-end mb-4">
          <!-- Ordinamento -->
          <div class="col-auto d-inline-block">
            <div ngbDropdown class="d-inline-block" container="body">
              <button type="button" class="btn btn-outline-primary btn-xs" [id]="'sortyBy' + props?.label"
                ngbDropdownToggle>
                Ordina per:
              </button>
              <div ngbDropdownMenu [attr.aria-labelledby]="'sortyBy' + props?.label" appendTo="body">
                <div ngbDropdownItem *ngFor="let order of sortByOptions" class=" ps-3 p-0">
                  <input (change)="sortFiles(order.value)" class="form-check-input p-0" type="radio"
                    [name]="order.label+'minicard'" [id]="order.label+'minicard'" [checked]="order.value === sortBy"
                    [value]="order.value">
                  <label class="form-check-label ps-2" style="font-size: .9rem;" [for]="order.label+'minicard'">
                    {{ order?.label }}
                  </label>
                </div>
              </div>
            </div>
          </div> <!-- /end of Ordinamento -->
          <!-- Elementi per pagina-->
          <div class="col-auto  d-inline-block" *ngIf="viewTemplate === 'pagination'">
            <div ngbDropdown class="d-inline-block" container="body">
              <button type="button" class="btn btn-outline-primary btn-xs" ngbDropdownToggle>
                {{ 'Elementi per pagina: ' + pageSize }}
              </button>
              <div ngbDropdownMenu [attr.aria-labelledby]="'pageSize' + props?.label" appendTo="body">
                <button ngbDropdownItem *ngFor="let size of [5, 10, 15]" class=" ps-3 p-0" (click)="onPageSize(size)">
                  {{ size }}
                </button>
              </div>
            </div>
          </div> <!-- /Elementi per pagina -->
        </div>
      </div>

      <ng-container [ngSwitch]="viewTemplate">

        <!--  CAROUSEL TEMPLATE -->
        <ng-container *ngSwitchCase="'carousel'">
          <ngb-carousel #carousel [showNavigationArrows]="true" [keyboard]="true" [showNavigationIndicators]="false"
            [interval]="0">
            <ng-template ngbSlide *ngFor="let group of files | groupFiles: (elementsToShow$ | async) || 5">
              <div class="row justify-content-center">
                <div class="card-wrapper col-2 me-4" *ngFor="let file of group">
                  <!-- card template outlet-->
                  <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: file }"></ng-container>
                  <!-- /end of card template outlet -->
                </div>
              </div>
            </ng-template>
          </ngb-carousel>
        </ng-container>

        <!-- PAGINATION TEMPLATE -->
        <ng-container *ngSwitchCase="'pagination'">
          <div class="row ps-3 w-100 justify-content-center">
            <div class="col-auto mb-2 p-0 me-3" *ngFor="let file of paginatedFiles">
              <!--card template outlet -->
              <div class="card-wrapper ">
                <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: file }"></ng-container>
              </div> <!--/end of card template outlet-->
            </div>
          </div>
          <ngb-pagination class="d-flex justify-content-center" [collectionSize]="files.length" [(page)]="page"
            [pageSize]="pageSize" size="sm" (pageChange)="onPageChange($event)"></ngb-pagination>
        </ng-container>

        <!-- GRID TEMPLATE -->
        <ng-container *ngSwitchDefault>
          <div class="row ps-3 w-100 justify-content-center">
            <div class="col-auto mb-2 p-0 me-3" *ngFor="let file of files">
              <!--card template outlet -->
              <div class="card-wrapper ">
                <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: file }"></ng-container>
              </div> <!--/end of card template outlet-->
            </div>
          </div>
        </ng-container>

      </ng-container>
    </div>
  </ng-container>
</ng-container>


<!-- MINI CARD ITEM TEMPLATE -->
<ng-template #cardTemplate let-file>
  <div class="card card-bg card-lg no-after border-primary" style="border-left: 4px solid">
    <div class="card-body p-2 d-flex row">
      <div class="mb-0 col-12 pt-1">
        <!-- icon container -->
        <span class="it-rounded-icon me-0" [ngSwitch]="file?.extension">
          <img src="assets/svg/file-pdf.svg" class="icon-danger icon icon-md imgshadow float-start me-1" alt="file pdf"
            *ngSwitchCase="'pdf'">
          <img src="assets/svg/file-excel.svg" class="icon-danger icon icon-md imgshadow float-start me-1"
            alt="file sheet" *ngSwitchCase="'xls'">
          <img src="assets/svg/file-excel.svg" class="icon-danger icon icon-md imgshadow float-start me-1"
            alt="file sheet" *ngSwitchCase="'xlsx'">
          <img src="assets/svg/file-zip.svg" class="icon-danger icon icon-md imgshadow float-start me-1" alt="file zip"
            *ngSwitchCase="'zip'">
          <img src="assets/svg/file-zip.svg" class="icon-danger icon icon-md imgshadow float-start me-1" alt="file rar"
            *ngSwitchCase="'rar'">
          <img src="assets/svg/file-doc.svg" class="icon-danger icon icon-md imgshadow float-start me-1" alt="doc"
            *ngSwitchDefault>
        </span>
        <!-- /end of icon container -->
        <p class="file-title mb-0" style="cursor: default;"
          [ngbTooltip]="getFileTitle(file).length > 12 ? getFileTitle(file) : ''"
          *ngIf="props?.showAction else linkTemplate">
          {{getFileTitle(file) |
          truncate: [12] }}
        </p>
        <ng-template #linkTemplate>
          <a href="javascript:void(0)" [ngbTooltip]="getFileTitle(file).length > 12 ? getFileTitle(file) : ''"
            (click)="downloadFile(file)" class="link-primary text-decoration-underline">
            {{ getFileTitle(file) |
            truncate: [12]}}
          </a>
        </ng-template>
      </div>
      <div class="it-card-footer col-12 mt-0 justify-content-end">
        <span class="it-multiple" *ngIf="props?.showAction">
          <div ngbDropdown class="d-inline-block" container="body" #dropdown="ngbDropdown">
            <button type="button" class="btn btn-primary btn-xs" [id]="file.title +'_action'" ngbDropdownToggle>
              Azioni
            </button>
            <div ngbDropdownMenu [attr.aria-labelledby]="file.title +'_action'" appendTo="body">
              <button (click)="showPreview(file)" ngbDropdownItem>Anteprima</button>
              <button (click)="downloadFile(file)" ngbDropdownItem>Download</button>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</ng-template>